import { useMutation, useQueryClient } from '@tanstack/react-query';

import { duplicateAdminConversationForm } from '@entities/AdminConversationCategory/api/handlers/duplicateAdminConversationForm';

export function useDuplicateAdminConversationFormQuery() {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: duplicateAdminConversationForm,
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['adminConversationCategories'] });
        },
    });
}
